<template>
  <div class="dialog_box" />
</template>

<script>
import QQAuth from '@/plugins/auth/qqAuth.js'

import {
  ClientCloseSelf, ClientSetUserInfo, ClientCloseTable
} from '@/api/clientApi.js'
import { tableKey } from '@/common/const.js'
import { CacheSessionGetSource, CacheSessionGetState } from '@/common/cache.js'
import api from '@/api'
import { reportServerId, openBuyDialogByAbTest } from '@/common/business.js'
import { RetCode } from '@/api/bussinessCode.js'
import { report } from '@/report/index.js'
import { parseURL } from '@/common/utils.js'

/** 环境判定 */
const isDev = process.env.NODE_ENV === 'development'
const isTest = process.env.STAGE === 'test'
const proxyUrl = `${isDev || isTest ? 'http' : 'https'}://pptpluginppt1.duba.com/vip_login_proxy.html`

export default {
  name: 'QQLoginDialog',

  computed: {
    dialogPayAbTestType () { // 支付窗abTest类型
      return this.$store.state.dialogPayAbTestType
    },
    isTestMidAutumn () {
      return this.$store.getters['abTest/isTestMidAutumn']
    },
  },

  mounted () {
    this.reportShow()

    const url = parseURL(location.href)
    if (url.params?.code) {
      this.checkUrlParams(url.params)
    } else {
      this.loginQQ()
    }
  },

  methods: {
    /** 上报-登录窗展示 **/
    reportShow () {
      report('login', { actiontype: 'loginshow', actionid: '', ext: '' })
    },

    /** 上报-qq登录成功 **/
    reportStepQQLogin (userType) {
      report('login', { actiontype: 'step', actionid: 2, ext: '' })
    },

    loginQQ () {
      window.open(new QQAuth().openAuthPage())
    },

    checkUrlParams (urlParams) {
      const searchState = urlParams.state
      const qqState = CacheSessionGetState()

      if (!searchState || searchState !== qqState) { return }

      this.userLogin(urlParams.code) // LoginType第三方接口传过去的参数
    },

    userLogin (code) {
      const params = { login_type: 2, code, login_app: 'chestnutoffice', channel: CacheSessionGetSource() || '', qq_redirect_url: encodeURIComponent(proxyUrl) }

      api.user.login({ data: params }).then(res => {
        const data = res.data

        const userType = data?.user_info?.is_new_user === 0 ? 2 : 1 // 默认是新注册

        // 存储userInfo，下一步上报需要
        const userInfo = { token: data.token, ...data.user_info }
        ClientSetUserInfo(userInfo)

        // 为新注册用户，需要上报serverId
        // 上报前需要设置store的token，上报需要token值
        this.$store.commit('vuexSetUserInfo', userInfo)
        if (userType === 1) {
          reportServerId()
        }

        this.getPrivliege(userInfo, userType) // 获取用户权益
      }).catch(() => {
        this.$toast({
          desc: '登录异常，请联系客服或关闭重试', fn: () => {
            ClientCloseSelf()
          }
        })
      })
    },

    getPrivliege (userInfo, userType) {
      let privliegeName = ''
      let privliegeEndTime = ''
      let isVip = false

      api.user.privliege({ data: { common: { token: userInfo.token, uid: userInfo.uid } } }).then(pRes => {
        privliegeName = pRes.data.name
        privliegeEndTime = pRes.data.end_date
        isVip = true
      }).catch(data => {
        if (data?.ret && data.ret.toString() in RetCode) {
          privliegeName = RetCode[data.ret]
        }
      }).finally(() => {
        const lastUserInfo = { privliegeName, privliegeEndTime, isVip, ...userInfo }

        ClientSetUserInfo(lastUserInfo)

        if (!isVip) {
          openBuyDialogByAbTest(this.$store)
        }

        this.closeTableWx()

        setTimeout(() => { // 上面方法s是微任务，所以，得给个异步
          ClientCloseSelf()
        }, 100)
      })
    },

    closeTableWx () {
      const { loginTable, loginTableNew } = tableKey
      const tableKeyClose = this.isTestMidAutumn ? loginTableNew : loginTable
      ClientCloseTable(tableKeyClose)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog_box { background-color: $bg; }
</style>
